import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import NonProfitBoardAuthorizationRuleset from '../../business/ruleset/NonProfitBoardAuthorizationRuleset';
import { RulesetResult } from '../../business/rules/';

const { nonProfitBoardResolution } = loanFormModel.formField.companyDocuments;

export class NonProfitBoardResolutionValidation implements ValidationSchema {
  public name = nonProfitBoardResolution.name;
  public label = nonProfitBoardResolution.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = NonProfitBoardAuthorizationRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required)
      return FileNameValidationSchema(
        nonProfitBoardResolution.name,
        true
      ).required('This document is required');
    return FileNameValidationSchema(nonProfitBoardResolution.name, false);
  }
}

export default new Validation(new NonProfitBoardResolutionValidation());
